import React from "react";

const PropertyFiltersContext = React.createContext({})

export default PropertyFiltersContext